<template>
 <div class=" apply-kcode">
    <div class="yto-box">
      <span class="systemColor title-box" @click="goBackPage"><svg-icon icon-class="icon_fanhui" class="icon-back-box"></svg-icon>返回</span>
      <el-button class="" type="primary" @click="goApplyKcodePage">申请客户编码</el-button>
    </div>
    <div class="yto-table yto-box">
      <el-table :data="tbodyList">
        <el-table-column prop="customerCode" label="客户编码" width="120"></el-table-column>
        <el-table-column prop="customerName" label="客户名称"></el-table-column>
        <el-table-column
          label="申请网点">
          <template slot-scope="scope">
            <span>{{(scope.row.orgCode || '') + '-' + (scope.row.orgName || '')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="审核状态">
          <template slot-scope="scope">
            <span v-text="getApproveStatus(scope.row.status)"></span>
            <el-tooltip class="item" effect="light" placement="bottom-end" v-if="scope.row.status==5">
              <span slot="content">
                <span>终止状态无法对“代收货款”的订单进行打印快递单操作，不允许拉取代收货款面单</span>
              </span>
              <i class="el-icon-question systemColor" style="margin-left: 10px; cursor: pointer" v-if="scope.row.status==5"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间">
          <template slot-scope="scope">
            <span>{{(scope.row.createTime&&scope.row.createTime.includes('T')?scope.row.createTime.split('T')[0]:scope.row.createTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="原因">
          <template slot-scope="scope">
            <span class="systemColor" style="cursor:pointer;" @click="viewReason(scope.row)" v-if="scope.row.statusMsg">查看</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editKcodeInfo(scope.row, 'view')">查看</el-button>
            <el-button type="text" size="small" @click="editKcodeInfo(scope.row, 'edit')" v-if="scope.row.status == -1">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查看失败原因 -->
    <el-dialog
      title="原因"
      :visible.sync="reasonDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      center>
      <div>{{reasonInfo.statusMsg || ''}}</div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { queryKApplyListApi } from '../../../../api/baseInfo/printSetting/electronicFaceAccount';
export default {
  data() {
    return {
      tbodyList: [],
      reasonDialogVisible: false,
      reasonInfo: {},
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  mounted() {
    localStorage.removeItem('view');
    console.log('this.$route.params',this.$route.query)
    if(this.$route.query&&this.$route.query.showGuidance==0){
       localStorage.removeItem('yto-guidance-show');
        window.localStorage.setItem('yto-guidance-show', 0);
        this.$store.commit('setSessionGuidanceShow', false);
        this.$store.commit('setGuidanceShow', false);
        document.getElementsByTagName('body')[0].classList.remove('drawer-scroll-guidance');
    }

    this.getKcodeList();
  },
  methods: {
    // 添加申请k码页面
    goApplyKcodePage() {
      this.$router.push({name: 'addKcodeInfo'});
    },
    // 返回
    goBackPage() {
      this.$router.push({name: 'ElectronicBillManagement'});
    },
    // 查看列表
    getKcodeList() {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      queryKApplyListApi({createUser:this.userMess.loginId}).then(res => {
        loadingMask.close();
        if (res.success) {
          this.tbodyList = res.data && res.data || [];
          if (!this.tbodyList.length) {
            localStorage.setItem('add', 'add');
            this.$router.push({ name: 'addKcodeInfo'});
          }
        } else {
          this.tbodyList = [];
        }
      }).catch(() => {
        loadingMask.close();
        this.tbodyList = [];
      });
    },
    // 查看原因   3000 150
    viewReason(row) {
      console.log('row', row);
      this.reasonInfo = row;
      this.reasonDialogVisible = true;
    },
    // 编辑K码信息
    editKcodeInfo(row, type) {
      localStorage.setItem('view', type);
      this.$router.push({ name: 'addKcodeInfo',params:{id:row.id}});
    },
    // 获取审核状态
    getApproveStatus(status) {
      let str = '';
      switch(status) {
        case 0:
          str = '待网点审核';
          break;
        case 1:
          str = '审核通过';
          break;
        case -1:
          str = '审核不通过';
          break;
        default:
          break;
      }
      return str;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
.title-box {
  padding-left: 20px;
  font-size: 14px;
  cursor: pointer;
  margin-right:15px;
}
.icon-back-box {
  width: 16px;
  height: 16px;
}
</style>
